import CardServer1 from './Card_Server_1';

const Content_Card_1 = ({ contentCard }) => {
  return <CardServer1 contentCard={contentCard} />;
};
export default Content_Card_1;
